import React from "react";

const ImageIcon = ({ fill = "#02C9A6" }) => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
  >
    <path
      d="M10.8373 10.8343C10.8373 11.2651 10.6662 11.6783 10.3615 11.9829C10.0569 12.2876 9.64372 12.4587 9.21291 12.4587C8.78209 12.4587 8.36891 12.2876 8.06428 11.9829C7.75964 11.6783 7.5885 11.2651 7.5885 10.8343C7.5885 10.4035 7.75964 9.99031 8.06428 9.68568C8.36891 9.38104 8.78209 9.2099 9.21291 9.2099C9.64372 9.2099 10.0569 9.38104 10.3615 9.68568C10.6662 9.99031 10.8373 10.4035 10.8373 10.8343Z"
      fill={fill}
    />
    <path
      d="M6.50556 5.96112C5.93114 5.96112 5.38024 6.18931 4.97406 6.59549C4.56788 7.00167 4.33969 7.55257 4.33969 8.12699V18.9564C4.33969 19.5308 4.56788 20.0817 4.97406 20.4879C5.38024 20.894 5.93114 21.1222 6.50556 21.1222H19.5008C20.0752 21.1222 20.6261 20.894 21.0323 20.4879C21.4385 20.0817 21.6667 19.5308 21.6667 18.9564V8.12699C21.6667 7.55257 21.4385 7.00167 21.0323 6.59549C20.6261 6.18931 20.0752 5.96112 19.5008 5.96112H6.50556ZM19.5008 7.04406C19.788 7.04406 20.0635 7.15815 20.2666 7.36124C20.4696 7.56433 20.5837 7.83978 20.5837 8.12699V15.1661L16.4935 13.0576C16.3919 13.0067 16.277 12.9891 16.1648 13.0072C16.0527 13.0252 15.9491 13.0781 15.8686 13.1583L11.8509 17.176L8.97033 15.257C8.86632 15.1878 8.74157 15.1567 8.61722 15.1689C8.49288 15.1811 8.37659 15.236 8.28808 15.3242L5.42263 17.8734V8.12699C5.42263 7.83978 5.53672 7.56433 5.73981 7.36124C5.9429 7.15815 6.21835 7.04406 6.50556 7.04406H19.5008Z"
      fill={fill}
    />
  </svg>
);

export default ImageIcon;

